import { useState, useEffect, useCallback } from 'react';

function useHeight(elementRef: any, isLoaded: any, isAssignment = false) {
  const [height, setHeight] = useState(null);
  const [offsetTop, setOffsetTop] = useState(null);
  const [offsetHeight, setOffsetHeight] = useState(null);

  const updateHeight = useCallback(() => {
    if (isLoaded && elementRef && elementRef.current && isAssignment) {
      setOffsetTop(elementRef.current.offsetTop);
      setOffsetHeight(elementRef.current.offsetHeight);
    } else if (isLoaded && elementRef && elementRef.current && isAssignment === false) {
      const elemHeight = elementRef.current.getBoundingClientRect().height;
      setHeight(elemHeight);
    }
  }, [isLoaded, elementRef]);

  useEffect(() => {
    updateHeight();
    window.addEventListener('resize', updateHeight);
    return () => {
      window.removeEventListener('resize', updateHeight);
    };
  }, [updateHeight]);

  return { height, offsetTop, offsetHeight };
}

export default useHeight;
